import React, { useContext, useEffect, useState } from 'react';
import { FC } from 'react';
import { useLocation, useParams } from 'react-router';
import { Button, Dialog, Link, makeStyles } from '@material-ui/core';
import { Provider, useDispatch, useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import store, { RootState } from 'src/store';
import GetCodeModal from 'src/components/Modal/GetCodeModal';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { API, Auth } from 'aws-amplify';
import { editUserCompany, editUserGrade } from 'src/store/modules/client';
import { editTemplateId, editTemplateName } from 'src/store/modules/template';
import { ReactComponent as Arrowleft } from 'src/assets/arrow-left.svg';
import { TEMPLATES_HTML } from 'src/constants/templatesComponent';
import { FREE_TEMPLATES, STARTER_TEMPLATES } from 'src/constants/templates';
import { AuthContext, AuthStatus } from 'src/contexts/authContext';
import GuestModal from 'src/components/Modal/GuestModal';
import ReactGA from 'react-ga4';
import * as Sentry from '@sentry/react';
import * as ChannelService from '@channel.io/channel-web-sdk-loader';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '3rem',
    minWidth: 1400,
    display: 'flex',
    zIndex: 100,
    backgroundColor: '#282828'
  },
  toolbar: {
    width: '100%',
    height: '3rem',
    margin: 'auto',
    padding: '0 2rem',
    display: 'flex',

    justifyContent: 'space-between',
    alignItems: 'center'
  },
  homeText: {
    width: '14.159375rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',

    color: '#fff',
    fontSize: '0.875rem',
    fontWeight: 400,
    letterSpacing: '0.0175rem'
  },

  uploadBtn: {
    width: 112,
    height: 32,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',

    outline: 'none',
    border: 'none',

    cursor: 'pointer',
    color: '#fff',
    fontSize: 12,
    fontWeight: 500,
    fontFamily: 'Archivo',
    textTransform: 'none',

    background: '#3D3D3D',
    '&:hover': {
      color: '#000000',
      background: '#f4f4f4'
    }
  },
  uploadIcon: {
    width: 16,
    height: 16,
    marginLeft: 4,
    '&:hover': {
      color: '#000000',
      background: '#f4f4f4'
    }
  },
  saveBtn: {
    // width: '4.375rem',
    height: '2rem',
    margin: 'auto',
    padding: 0,

    outline: 'none',
    border: 'none',
    borderRadius: '0.5rem',

    cursor: 'pointer',
    color: '#fff',
    fontSize: '0.875rem',
    fontWeight: 400,
    fontFamily: 'Archivo',
    letterSpacing: '0.0175rem',

    background: '#3D3D3D',
    '&:hover': {
      // color: '#000000',
      background: '#f4f4f4'
    }
  },
  exportBtn: {
    // width: '7.25rem',
    height: '2rem',
    margin: 'auto',
    padding: '0 1rem',

    outline: 'none',
    border: 'none',
    borderRadius: '0.5rem',

    cursor: 'pointer',
    color: '#fff',
    fontSize: '0.875rem',
    fontWeight: 400,
    fontFamily: 'Archivo',
    letterSpacing: '0.0175rem',

    background: '#3D3D3D',
    '&:hover': {
      // color: '#000000',
      background: '#f4f4f4',
      a: {
        color: '#000000'
      }
    }
  },
  csvBtnWrapper: {
    height: '2rem',
    margin: 'auto',
    padding: 0,

    outline: 'none',
    border: 'none',
    borderRadius: '0.5rem',

    cursor: 'pointer',
    color: '#fff',
    fontSize: '0.875rem',
    fontWeight: 400,
    fontFamily: 'Archivo',
    letterSpacing: '0.0175rem',

    background: '#3D3D3D',
    '&:hover': {
      color: '#000000',
      background: '#f4f4f4',
      a: {
        color: '#000000'
      }
    }
  },
  csvBtn: {
    width: '100%',
    height: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    textDecoration: 'none',
    '&:hover': {
      color: '#000000'
    }
  },

  dialog: {
    top: 0,
    right: 0,
    position: 'fixed',
    width: '50%',
    margin: 0,
    height: '100%',
    maxHeight: 'max-content',
    borderRadius: 0
  },
  sizeIcon: {
    width: '1.5rem',
    height: '1.5rem',
    marginLeft: 12,
    border: 'none',

    cursor: 'pointer',
    borderRadius: '999px',
    backgroundColor: '#4F4F4F'
    // position: 'absolute',
    // top: 1
  },
  imageGuide: {
    position: 'absolute',
    top: 20,
    left: '98%'
  }
}));
const NavTop: FC = () => {
  let templateTitle = useSelector(
    (state: RootState) => state.template.templateTitle
  );
  let templateName = useSelector(
    (state: RootState) => state.template.templateName
  );
  let userCompany = useSelector((state: RootState) => state.client.userCompany);
  let starIndex = useSelector(
    (state: RootState) => state.imageUpload.starIndex
  );
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgVideo = useSelector((state: RootState) => state.imageUpload.bgVideo);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  let btnTextAlign = useSelector(
    (state: RootState) => state.buttons.btnTextAlign
  );
  let btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let button1 = useSelector((state: RootState) => state.trackings.button1);
  let button2 = useSelector((state: RootState) => state.trackings.button2);
  let logCustom = useSelector((state: RootState) => state.trackings.logCustom);
  let btnType = useSelector((state: RootState) => state.buttons.btnType);
  let switchDarkMode = useSelector(
    (state: RootState) => state.switchButton.switchDarkMode
  );
  let switchPosition = useSelector(
    (state: RootState) => state.switchButton.switchPosition
  );
  let switchMediaType = useSelector(
    (state: RootState) => state.switchButton.switchMediaType
  );
  let userGrade = useSelector((state: RootState) => state.client.userGrade);

  const classes = useStyles();
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [brazeCode, setBrazeCode] = useState<string | string[]>(
    '이 템플릿을 사용할 권한이 없습니다.'
  );
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [freeExpired, setFreeExpired] = useState(true);
  const [company, setCompany] = useState(userCompany);
  const [exportedCount, setExportedCount] = useState(0);
  const onClickGuestModal = () => {
    setShowModal(prev => !prev);
  };

  const FINAL_VALUES = {
    company: company,
    starIndex: starIndex,

    bgColor: bgColor,
    bgImage: bgImage,
    bgVideo: bgVideo,
    bgOpacity: bgOpacity,
    deeplink: deeplink,
    radius: radius,

    text: text,
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    fontFamily: fontFamily,
    textAlign: textAlign,

    btnText: btnText,
    btnFontSize: btnFontSize,
    btnFontWeight: btnFontWeight,
    btnColor: btnColor,
    btnBgColorR: btnBgColorR,
    btnBgColorG: btnBgColorG,
    btnBgColorB: btnBgColorB,
    btnBgColorA: btnBgColorA,
    btnFontFamily: btnFontFamily,
    btnTextAlign: btnTextAlign,
    btnAgain: btnAgain,

    tracking: tracking,
    button1: button1,
    button2: button2,
    logCustom: logCustom,
    btnType: btnType,
    switchDarkMode: switchDarkMode,
    switchPosition: switchPosition,
    switchMediaType: switchMediaType
  };

  const TEMPLATE_TITLE = location?.pathname?.split('/')?.[2];

  const TITLE = location?.pathname
    ?.split('/')?.[2]
    ?.split('-')
    ?.join(' ')
    ?.toUpperCase();

  const { authStatus } = useContext(AuthContext);
  ChannelService.loadScript();

  useEffect(() => {
    async function onLoad() {
      try {
        if (location?.pathname?.split('/')?.[3] !== undefined) {
          const data = await API.get('iam-editor', `/templates/${id}`, '');
          dispatch(editTemplateName(data?.templateName));
        }
      } catch (error) {
        history.replace(`/editor/${TEMPLATE_TITLE}`);
      }

      try {
        const result = await API.get(
          'iam-editor',
          '/subscription/subscription-info',
          ''
        );
        dispatch(editUserCompany(result?.companyName));
        setCompany(result?.companyName);

        if (
          result.subscriptionExpireDate &&
          result.subscriptionExpireDate - Date.now() > 0 &&
          !result.subscription
        ) {
          setFreeExpired(false);
          dispatch(editUserGrade('PRO'));
        } else if (
          result.subscriptionExpireDate &&
          result.subscriptionExpireDate - Date.now() > 0 &&
          result.subscription
        ) {
          if (STARTER_TEMPLATES.includes(TITLE)) {
            setFreeExpired(false);
          } else {
            setFreeExpired(true);
          }
          dispatch(editUserGrade('STARTER'));
        } else if (
          result.freeTrialExpireDate &&
          result.freeTrialExpireDate - Date.now() > 0
        ) {
          setFreeExpired(false);
          dispatch(editUserGrade('PRO'));
        } else {
          if (FREE_TEMPLATES.includes(TITLE)) {
            setFreeExpired(false);
          } else {
            setFreeExpired(true);
          }
          setExportedCount(result.exportCount ?? 0);
          dispatch(editUserGrade('FREE'));
        }

        ChannelService.boot({
          pluginKey: process.env.REACT_APP_PLUGIN_KEY,
          memberId: result.userId,
          profile: {
            name: result.companyName,
            email: result.companyEmail
          }
        });
      } catch (error) {}
    }
    if (authStatus !== AuthStatus.SignedIn) return;
    onLoad();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  async function handleExport(event: any) {
    event.preventDefault();
    authStatus === AuthStatus.SignedIn
      ? ReactGA.event('user_export_event', {})
      : ReactGA.event('guest_export_event', {});

    if (authStatus !== AuthStatus.SignedIn) {
      onClickGuestModal();
      return;
    }
    if (freeExpired) {
      if (userGrade === 'FREE') {
        alert('Available after PRO or STARTER subscription.');
        return;
      }
      if (userGrade === 'STARTER') {
        alert('This template is only available with PRO subscription.');
        return;
      }
    } else {
      try {
        if (userGrade === 'FREE') {
          if (exportedCount > 49) {
            alert('You have used up all your export count.');
            return;
          }
          const remainCount = await exportCount(exportedCount);
          setExportedCount(remainCount?.exportCount);
        }

        const returnId = await saveTemplate(id);
        if (returnId !== null) {
          dispatch(editTemplateId(returnId));
          history.push(
            `/editor/${TITLE.toLowerCase()
              .split(' ')
              .join('-')}/${returnId}`
          );
        }
        const htmlString = ReactDOMServer.renderToString(
          <Provider store={store}>{TEMPLATES_HTML[TITLE]}</Provider>
        );
        const isExport = await exportTemplate(returnId, htmlString);
        if (isExport) {
          const code = `<html>${htmlString}</html>`;
          const frontBody = code.split('<body>')[0];
          const bodyContent = `<body>${
            code.split('<body>')[1].split('</body>')[0]
          }</body>`;
          const backBody = code.split('</body>')[1];
          const CODE = [
            btoa(unescape(encodeURIComponent(frontBody))),
            bodyContent,
            btoa(unescape(encodeURIComponent(backBody)))
          ];
          setBrazeCode(CODE);
          setOpen(true);
        }
      } catch (error) {}
    }
  }

  async function exportTemplate(id: string, htmlString: any) {
    try {
      return await API.post('iam-editor', '/templates/export', {
        body: {
          htmlFile: htmlString,
          client: userCompany.replaceAll(' ', '-'),
          templateId: id
        }
      });
    } catch (error) {
      // Sentry.captureMessage('export error');
      Sentry.captureException(error?.response);
      if (error?.response?.status === 403) {
        alert('Authentication failed, please login again');
        return;
      }
    }
  }

  async function exportCount(count) {
    try {
      return await API.post('iam-editor', '/iam-update', {
        body: {
          exportCount: count
        }
      });
    } catch (error) {
      // Sentry.captureMessage('free export error');
      Sentry.captureException(error?.response);
      if (error?.response?.status === 403) {
        alert('Authentication failed, please login again');
        return;
      }
    }
  }

  async function handleSave(e: any) {
    e.preventDefault();
    authStatus === AuthStatus.SignedIn
      ? ReactGA.event('user_save_event', {})
      : ReactGA.event('guest_save_event', {});

    if (authStatus !== AuthStatus.SignedIn) {
      onClickGuestModal();
      return;
    }
    try {
      const returnId = await saveTemplate(id);
      if (returnId !== null) {
        alert('Save Successful');
        history.push(
          `/editor/${TITLE.toLowerCase()
            .split(' ')
            .join('-')}/${returnId}`
        );
      }
    } catch (error) {
      // Sentry.captureMessage('save error');
      Sentry.captureException(error?.response);
      if (error?.response?.status === 403) {
        alert('Authentication failed, please login again');
        return;
      }
    }
  }

  async function saveTemplate(id: string) {
    const current = await Auth.currentUserInfo();
    setCompany(current.attributes['custom:Company']);
    if (id) {
      return API.put('iam-editor', `/templates/${id}`, {
        body: {
          customValues: FINAL_VALUES,
          templateName: templateName === '' ? TITLE : templateName,
          clientName: current.attributes['custom:Company'].replaceAll(' ', '-')
        }
      });
    } else {
      return API.post('iam-editor', '/templates/save', {
        body: {
          customValues: FINAL_VALUES,
          iamType: templateTitle,
          templateName: templateName === '' ? TITLE : templateName,
          clientName: current.attributes['custom:Company'].replaceAll(' ', '-')
        }
      });
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.toolbar}>
        <Link
          component={RouterLink}
          to={
            authStatus === AuthStatus.SignedIn
              ? '/workspace/draft'
              : '/workspace/templates'
          }
          className={classes.homeText}
        >
          <Arrowleft
            style={{
              width: '1.5rem',
              height: '1.5rem',
              marginRight: 8
            }}
          />
          <span>BACK</span>
        </Link>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            margin: 'auto'
          }}
        >
          <span
            style={{
              fontWeight: 600,
              color: '#fff'
            }}
          >
            {templateName === '' ? TITLE : templateName}
          </span>
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <Button className={classes.uploadBtn} onClick={handleSave}>
            <span>SAVE</span>
          </Button>
          <Button onClick={handleExport} className={classes.uploadBtn}>
            <span>GET CODE</span>
          </Button>
        </div>

        <Dialog open={open} onClose={handleClose}>
          <GetCodeModal handleClose={handleClose} getCode={brazeCode} />
        </Dialog>
      </div>
      {showModal && <GuestModal onClickGuestModal={onClickGuestModal} />}
    </div>
  );
};

export default NavTop;
